module.exports = __webpack_public_path__ + "static/media/5.ebaa8f4f.jpg";